/**
 * =================
 * LIGHTBOX (lity wrapper func)
 * tool
 * =================
 */
app.lightbox = (function(module) {

	var $doc = app.$(document);

	// lightbox instance (initialized)
	var lightbox = lity();

	// init (open with options)
	module.init = lightbox.open;

	// close member
	module.close = lightbox.close;

	// invoque AJAX lightbox
	// programatically create an individual lightbox instance
	module.ajax = function(url, callback) {
		// inline layer and id
		var layerId = "layer_" + Math.random().toString().slice(10),
		    $ilayer = app.$('<div id="'+ layerId +'" class="lity-hide" />').appendTo("body");

		// fetch AJAX url
		app.$.get(url, function(response) {
			// inject content
			$ilayer.html(response);

			// up lightbox
			lightbox('#' + layerId);

			// exec callback
			callback && module.onOpen(function(ev, lbox, trigger) {
				var _self = this;
				try {
					window[callback].apply(_self, [ev, lbox, trigger]);
				} catch(ex) {
					console.debug("provided handler "+ callback.toString() + " doesn't exist");
				}
			});

			// destroy (unbounding true)
			module.onRemove(function(ev, lbox) {
				$ilayer.remove();
			}, true);
		});
	};

	// expose events to app ns
	app.$.each([
		"lity:open",
		"lity:ready",
		"lity:close",
		"lity:remove",
		"lity:resize"
	], function(i, ev) {
		// pub event name (replace ns and camelCase)
		var name = ev.replace('lity:', 'on_').replace(/\_+(.)/g, function(match, char) {
			return char.toUpperCase();
		});

		// expose event callback (one event or on, unbound vs persistent)
		module[name] = function(callback, unbounding) {
			$doc[(unbounding && "one" || "on")](ev, callback);
		};
	});

	// onReady persistent hooks
	module.onReady(function(ev, lbox, trigger) {
		var $target = app.$(ev.target);
		_hookCloseButton(lbox);

		// don't let close on outside click if provided
		// @TODO: lock via options?
		if ($target.attr("data-lightbox-locked")) {
			lbox.addClass("lightbox-locked")
			 .find(".lity-wrap")
			  .removeAttr("data-lity-close");
		}
	});

	// onClose outside persistent hook
	module.onClose(function(ev, lbox, trigger) {
		// ...
	});

	//
	// bind as an event handler (delegated on doc)
	//
	$doc.on("click", '[data-lightbox], [data-lightbox-ajax]', function(e) {
		var $this = app.$(this);

		// inline callback handler
		var ihandler = $this.attr("data-lightbox-handler");

		// AJAXED!
		if ($this.is('[data-lightbox-ajax]')) {
			e.preventDefault();
			module.ajax(this.href, ihandler);
			return;
		}

		lightbox.apply(this, [e]);
		ihandler && module.onOpen(function(ev, lbox, trigger) {
			var _self = this;
			try {
				window[ihandler].apply(_self, [ev, lbox, trigger]);
			} catch(ex) {
				console.log("provided inline handler "+ ihandler.toString() + " doesn't exist");
			}
		});

		// single unbounding events (true)
		module.onReady(function(ev, lbox, trigger) { /* ... */ }, true);
	});

	// inlined close button
	$doc.on("click", '.lightbox-close, #search-layer [type=reset]', function(e) {
		e.preventDefault();
		module.close();
	});

	// if an inline closer is provided, hide native closer
	function _hookCloseButton(lbox) {
		var $lboxClose = lbox.find(".lightbox-close"),
		    $lityClose = lbox.find(".lity-close");

		if ($lboxClose.length) {
			$lityClose.css("display", "none");
		}
	}

	return module;

}(app.lightbox || {}));
